@if (errors) {
  <div>
    <div *ngFor="let e of errors | keyvalue">
      <div [ngSwitch]="e.key">
        <small *ngSwitchCase="'required'" class="form-danger"
          >Campo obbligatorio</small
        >
        <small *ngSwitchCase="'email'" class="form-danger"
          >Inserire un indirizzo email valido</small
        >
        <small *ngSwitchCase="'pattern'" class="form-danger"
          >La password deve contenere almeno 8 caratteri, un carattere
          maiuscolo, un carattere minuscolo, un numero, ed un carattere
          speciale.</small
        >
        <small *ngSwitchCase="'onlyString'" class="form-danger"
          >Sono permesse solo lettere.</small
        >
        <small *ngSwitchCase="'onlyNumber'" class="form-danger"
          >Sono permessi solo numeri.</small
        >
        <small *ngSwitchCase="'fiscalCodePattern'" class="form-danger">
          Il codice fiscale non è valido</small
        >
        <small *ngSwitchCase="'max'" class="form-danger">{{
          "Il valore non può essere maggiore di " + e.value.max
        }}</small>
        <small *ngSwitchDefault class="form-danger">
          {{ e.value?.message || e.value }}
        </small>
      </div>
    </div>
  </div>
}
